// Single source for the API base URL. Read once from Vite's env at build
// time; falls back to the local dev worker on http://localhost:8787 when
// VITE_API_BASE_URL isn't set.
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8787";

// Public Google OAuth client id, used by the inline Google Identity
// Services one-tap signup on /signup. Same value as the server-side
// GOOGLE_OAUTH_CLIENT_ID secret on the admin-api worker (the client id
// is not a secret — it ships to every browser anyway). Empty string =
// the Google button is hidden and the page falls back to magic-link.
export const GOOGLE_OAUTH_CLIENT_ID =
  (import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID as string | undefined) ?? "";
